import React from 'react'
import styled, { css } from 'styled-components/macro'
import { Text, Button } from 'components/atoms'
import PropTypes from 'prop-types'

const MenuAccordionItem = ({
  title, onClick, isOpen, children, isFirst, isStretched,
}) => (
  <Accordion>
    <Accordion.Title modifiers={['stretch', 'leftAlign']} onClick={onClick} isFirst={isFirst}>
      {title}
    </Accordion.Title>
    {isOpen && (
      <Accordion.Content isStretched={isStretched}>
        {children}
      </Accordion.Content>
    )}
  </Accordion>
)

const Accordion = styled.div`
  border-bottom: 0;
`

Accordion.Title = styled(Button)(props => css`
  padding: ${props.theme.spacing.xs2} ${props.theme.spacing.s};
  border-top: 1px solid ${props.theme.colors.borderLighter};
  border-bottom: 1px solid ${props.theme.colors.borderLighter};
  border-right: 0px;
  border-left: 0px;
  font-weight: ${props.theme.weight.xbase};
  background-color: ${props.theme.colors.bg};
  ${props.isFirst && css`border-bottom: 0px;`};
  cursor: pointer;
  &:focus {
    background-color: ${props.theme.colors.bg};
  }
`)

Accordion.Content = styled.div(props => css`
  background-color: ${props.theme.colors.bgLighterS};
  padding: ${props.isStretched ? 0 : `${props.theme.spacing.m} ${props.theme.spacing.s}`};
`)

MenuAccordionItem.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  isFirst: PropTypes.bool,
  isStretched: PropTypes.bool,
  children: PropTypes.node,
}

MenuAccordionItem.defaultProps = {
  onClick: () => null,
  isOpen: false,
  isFirst: false,
  isStretched: false,
  children: <Text>Sem opções</Text>,
}

export default MenuAccordionItem
